const searchModal = document.querySelector('#search-modal');
const searchDialog = searchModal?.querySelector('.search-modal__content');

if (searchModal && searchDialog) {
  searchDialog.addEventListener('click', (event) => {
    if (event.target === searchDialog) searchModal.closeDialog();
  });

  searchModal.addEventListener('dialog:open', () => {
    requestAnimationFrame(() => {
      searchDialog.querySelector('.search-input')?.focus({ preventScroll: true });
    });
  });
}
